module.exports = __webpack_public_path__ + "img/jboard_icon-38.4691a61c.png";